import React from "react";
import { Workflow, BCMSRecord, useBCMSContext, useParams, useModel } from "@bcm-dev/bcms-vite";
import SelectCashAmountPage from "components/pages/SelectCashAmountPage";
import AccessCodePage from "components/pages/AccessCodePage";
import { Card } from "model";
const steps = [<SelectCashAmountPage/>,<AccessCodePage/>]


/**
 * @function CardFreeCashWorkflow
 * @returns {React.Component}
 * @description The main component for the balance transfers workflow.
 * @exported true
 * @example <CardFreeCashWorkflow />
 */
export default function CardFreeCashWorkflow(props) {
    const controller = useBCMSContext();
    const cardID = useParams().cardID ?? "0";
    const model = useModel();
    const value = getDefault(controller,cardID);
    return <Workflow value={ value } steps={ steps } />;
}

/**
 * @function getWorkflowSteps
 * @returns {ARRAY}
 * @description Hook to return the steps of the workflow
 * @exported true
 */
export const getWorkflowSteps = () => steps;

/**
 * @function getDefault
 * @returns {OBJECT}
 * @exported true
 * @description Returns the default values for the travel plan
 */
export const getDefault = (controller,cardID) => {
    BCMSRecord.globalControllerFor([Card ], controller);
  
    return {
        card:Card.initByID(cardID),
        cashAmount: "$20",
       
     
    }
};